/**
 * Which x-axis tick of the drying graph is the axis's start or end. The graph sets the axis `min` and
 * `max`, and Chart.js then always adds both as ticks, at the exact start and end, around its round
 * values: [start, 25.09., 27.09., …, 07.10., end]. So the start is the first tick and the end the last.
 *
 * It used to be told by value, within half the gap between the first two ticks of the start or end.
 * That gap runs from the start to the first round value, not one step, so with a drying starting at
 * 12:18 the tolerance came to 18 hours: the round tick "07.10." 16 hours before an end at 16:48 also
 * counted as the end, got the end's date-and-time label and was drawn over it (Taimoor, 2026-10-07).
 * By position, that tick is an ordinary one, and the rule that hides ticks too close to either end
 * applies to it.
 */
export interface AxisBoundaryTick {
  isFirst: boolean;
  isLast: boolean;
}

/** The tick at `index` of `tickCount` ticks: the axis start (first) or end (last), or neither. */
export function getAxisBoundaryTick(index: number, tickCount: number): AxisBoundaryTick {
  return { isFirst: index === 0, isLast: tickCount > 0 && index === tickCount - 1 };
}
